import FormComponent from "../../components/global/FormComponent";

const responseFormConfig = [
  {
    field: {
      type: "text",
      title: "Response",
      name: "response",
      placeholder: "Provide response",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Field is required",
      },
    },
  },
];

function QueryResponse({ handleAddOrUpdate, closePopup, messageFormConfig }) {
  const formConfig = messageFormConfig ? messageFormConfig : responseFormConfig;
  return (
    <FormComponent
      formConfig={formConfig}
      buttonText={"Send"}
      closePopup={closePopup}
      handleAddOrUpdate={handleAddOrUpdate}
    />
  );
}
export default QueryResponse;
